"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _extrablockUtils = _interopRequireDefault(require("../util/extrablockUtils"));
require("../playground/blocks/block_expansion_weather");
require("../playground/blocks/block_expansion_festival");
require("../playground/blocks/block_expansion_behaviorconduct_disaster");
require("../playground/blocks/block_expansion_behaviorconduct_lifesafety");
require("../playground/blocks/block_expansion_emergencyActionGuidelines");
require("../playground/blocks/block_expansion_disasterAlert");
var Expansion = exports["default"] = /*#__PURE__*/function () {
  function Expansion(playground) {
    (0, _classCallCheck2["default"])(this, Expansion);
    this.playground = playground;
  }
  return (0, _createClass2["default"])(Expansion, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var blockObject;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              blockObject = {};
              Object.entries(Entry.EXPANSION_BLOCK).forEach(function (_ref) {
                var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];
                if (!value.disabled) {
                  Entry.EXPANSION_BLOCK_LIST[key] = value;
                }
                if ('getBlocks' in value) {
                  (0, _extends2["default"])(blockObject, value.getBlocks());
                }
              });
              Entry.block = (0, _extends2["default"])(Entry.block, blockObject);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "banAllExpansionBlock",
    value: function banAllExpansionBlock() {
      _extrablockUtils["default"].banAllBlocks(this.playground, Entry.EXPANSION_BLOCK_LIST);
    }
  }, {
    key: "banExpansionBlocks",
    value: function banExpansionBlocks(expansionNames) {
      _extrablockUtils["default"].banBlocks(expansionNames, Entry.EXPANSION_BLOCK_LIST, function (expansionTypes) {
        return Entry["do"]('objectRemoveExpansionBlocks', expansionTypes).isPass(true);
      });
    }
  }, {
    key: "isActive",
    value: function isActive(expansionName) {
      return _extrablockUtils["default"].isActive(expansionName, Entry.EXPANSION_BLOCK_LIST);
    }
  }, {
    key: "addExpansionBlocks",
    value: function addExpansionBlocks(blockNames) {
      Entry["do"]('objectAddExpansionBlocks', blockNames);
    }
  }, {
    key: "getExpansions",
    value: function getExpansions(blockList) {
      return _extrablockUtils["default"].getExtras(blockList, 'category_expansion');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // 우선 interface 만 정의함.
    }
  }]);
}();